import { render } from "./TopHeaderAlarmBar.vue?vue&type=template&id=06d6c32e&scoped=true"
import script from "./TopHeaderAlarmBar.vue?vue&type=script&lang=js"
export * from "./TopHeaderAlarmBar.vue?vue&type=script&lang=js"

import "./TopHeaderAlarmBar.vue?vue&type=style&index=0&id=06d6c32e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Desktop\\project\\sparta\\sparta-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d6c32e"]])

export default __exports__